import { AuthenticationAdminResponse, AdminLoginRequest } from '@beable/roster-backend-client-v1';
import RosterBackendService from './RosterBackendService';
import { unicodeSafeDecode, unicodeSafeEncode } from '../util/encode';

interface Inputs {
  username: string;
  password: string;
  originUrl: string;
}

async function login(
  inputs: Inputs,
): Promise<AuthenticationAdminResponse | null> {
  const request: AdminLoginRequest = {
    username: inputs.username,
    password: inputs.password,
    originUrl: inputs.originUrl,
  };

  const response = await RosterBackendService.authenticate(request);
  if (response.isOk() && response.value && response.value.username) {
    const adminUser: AuthenticationAdminResponse = response.value;
    const sessionDuration = adminUser.sessionDuration
      ? adminUser.sessionDuration * 1000
      : 3600000;
    adminUser.sessionEnd = new Date().getTime() + sessionDuration;
    unsetUser();
    return adminUser;
  }
  return null;
}

async function singleSignOn() {
  const response = await RosterBackendService.authenticateSso();
  if (response.isOk() && response.value && response.value.length) {
    window.location.replace(response.value);
  }
}

function logout() {
  unsetUser();
  RosterBackendService.logout({} as any);
}

function isLoggedIn() {
  const adminUser = getUser();
  //TODO: add some checks here
  return !!adminUser;
}

function setUser(data: AuthenticationAdminResponse) {
  if (!getUser()) {
    sessionStorage.setItem('user', unicodeSafeEncode(JSON.stringify(data)));
  }
}

function getUser(): AuthenticationAdminResponse | undefined {
  const userEncoded = sessionStorage.getItem('user');

  if (!userEncoded) {
    return;
  }

  const userJson = unicodeSafeDecode(userEncoded);

  if (!userJson) {
    try {
      logout()
    } catch (e) {
      // do nothing
    }
    return;
  }
  
  const user = JSON.parse(userJson) as AuthenticationAdminResponse;

  return user;
}

function unsetUser() {
  sessionStorage.removeItem('user');
}

export default {
  login,
  logout,
  isLoggedIn,
  setUser,
  getUser,
  unsetUser,
  singleSignOn,
};
